import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment ProfileWorkingPreferences_org on Org
    @argumentDefinitions(
      calendarIds: { type: "[String]!" }
      userIds: { type: "[String]!" }
      teamHealthCalendarId: { type: "String!" }
    ) {
      summarizedWorkingPreferences(calendarId: $teamHealthCalendarId) {
        busiestDay
        mostFocusTime
        mostBookedRoom
      }
      workingGroups(first: 1000000) {
        edges {
          node {
            rooms {
              roomId
              name
            }
          }
        }
      }
      meetingHoursQueryResult(
        userIds: $userIds
        nonUserCalendarIds: $calendarIds
        resolveOverrides: false
      ) {
        calendarMeetingHours(first: 1000000) {
          edges {
            node {
              id
              calendarId
              workingHours {
                timeZone
                type
                daySettings {
                  day
                  setting {
                    minSlot
                    maxSlot
                    excludedSlots
                  }
                }
                dayOverrides {
                  date
                  setting {
                    minSlot
                    maxSlot
                    excludedSlots
                  }
                }
              }
            }
          }
        }
        userMeetingHours(first: 1000000) {
          edges {
            node {
              id
              workingHours {
                timeZone
                type
                daySettings {
                  day
                  setting {
                    minSlot
                    maxSlot
                    excludedSlots
                  }
                }
                dayOverrides {
                  date
                  setting {
                    minSlot
                    maxSlot
                    excludedSlots
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};
